import { defineStore } from "pinia";

export const useVersionUpdateStore = defineStore("versionupdate", {
  state: () => ({
    versionUpdateOption: null,
    versionUpdateUserAction: null,
  }),
  getters: {
    getVersionUpdateOption: (state) => state.versionUpdateOption,
    getVersionUpdateUserAction: (state) => state.versionUpdateUserAction,
  },
  actions: {
    setVersionUpdateOption(option) {
      this.versionUpdateOption = option;
    },
    setVersionUpdateUserAction(action) {
      this.versionUpdateUserAction = action;
    },
  },
  persist: {
    key: "LNSVersionUpdateCookies",
  },
});
